module.exports = __webpack_public_path__ + "static/media/65.59e87a14.png";